export const STORAGE_NAME_LOCALE = 'locale';

export const EN = 'en';
export const RU = 'ru';
